import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoFacturacionParametrosPage: React.FC = () => (
  <CatalogoPageLayout
    title="Parámetros de facturación"
    description="Mantené unidades, impuestos, condiciones de venta y medios de pago fiscales."
    helperText="Este catálogo alimenta la facturación electrónica y los formularios de ventas."
  />
);

export default CatalogoFacturacionParametrosPage;
